/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import EstateListCard from './EstateListCard'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'

function EstateListPage () {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'estates',
    defaultMessage: 'Biens'
  })

  const [searchParams, setSearchParams] = useQueryParams()

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <EstateListCard
          query={searchParams}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default EstateListPage
